import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import { i18n } from '@/main.js'
import requestCooperateNextengine from './request/requestCooperateNextengine'
import requestEcGoodsLink from './request/requestEcGoodsLink'
import requestNextengineCooperateConfigUpdate from './request/requestNextengineCooperateConfigUpdate'
import requestEcReceiveorderRegister from './request/requestEcReceiveorderRegister'
import { fileUploadApiResult } from '@/config'

const Actions = {
  // ネクストエンジン初回連携
  cooperateNextengineFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestCooperateNextengine.request.createRequest(params)

    return await axios
      // .get(apiMock.STOCK_MOVE_ARRIVAL_OPERATION)
      .post(`${api.COOPERATE_NEXTENGINE}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // EC商品マスタ一覧取得
  getEcGoodsListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    const ret = await axios
      .get(api.EC_GOODS_LIST)
      .then((response) => {
        const path = mutationsTypes.NEXTENGINE_SET_EC_GOODS_LIST
        commit(path, response.data)
        const getData = getters.getEcGoodsListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // uiControll.commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // EC商品・Spes商品マスタ連携
  ecGoodsLinkFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestEcGoodsLink.request.createRequest(params)

    return await axios
      // .get(apiMock.STOCK_MOVE_ARRIVAL_OPERATION)
      .post(`${api.EC_GOODS_LINK}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // EC商品マスタ一覧取得
  getEcGoodsCsvFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    const ret = await axios
      .get(api.EC_GOODS_CSV_DOWNLOAD)
      .then((response) => {
        const path = mutationsTypes.LEDGER_SHEET_HEADER
        commit(path, response)
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // EC商品一覧CSVアップロード
  ecGoodsCsvUploadFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    file
  ) => {
    const instance = axios.create({
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    await getCsrfToken()
    return await instance
      // .get(apiMock.ETERNAL_SYSTEM_CSV_UPLOAD)
      .post(api.EC_GOODS_CSV_UPLOAD, file)
      .then((response) => {
        const ret = commonUtil.afterApiSuccessProcess(
          response,
          response.data.data
        )
        alert(
          response.data.data.total +
            i18n.tc('nextengine.nextengine_ec-goods-csv-upload-success-message')
        )
        return ret
      })
      .catch((error) => {
        if (error.response.data.data && error.response.data.data.errorList) {
          const errors = []
          error.response.data.data.errorList.forEach((ele) => {
            for (const index in ele.errors) {
              ele.errors[index].flat().forEach((error) => {
                const errorMsg =
                  i18n.locale === 'cn'
                    ? `第${ele.lineNumber}行 ${error}`
                    : `${ele.lineNumber}行目 ${error}`
                errors.push(errorMsg)
              })
            }
          })

          alert(`${errors.join('\n')}`)
          return false
        }
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // EC取込受注伝票一覧取得
  getEcReceiveorderListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const ret = await axios
      .get(api.EC_RECEIVEORDER_LIST, { params: params })
      .then((response) => {
        const path = mutationsTypes.NEXTENGINE_SET_EC_RECEIVEORDER_LIST
        commit(path, response.data)
        const getData = getters.getEcReceiveorderListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // uiControll.commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // EC取込受注伝票から販売登録
  registerSaleFromEcReceiveorderFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestEcReceiveorderRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.STOCK_MOVE_ARRIVAL_OPERATION)
      .post(`${api.EC_RECEIVEORDER_REGISTER}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // NE連携設定取得
  getNextengineCooperateConfigFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    const ret = await axios
      .get(api.NEXTENGINE_COOPERATE_CONFIG)
      .then((response) => {
        const path =
          mutationsTypes.NEXTENGINE_SET_NEXTENGINE_COOPERATE_CONFIG_DATA
        commit(path, response.data)
        const getData = getters.getNextengineCooperateConfigFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // uiControll.commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // EC商品・Spes商品マスタ連携
  updateNextengineCooperateConfigFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestNextengineCooperateConfigUpdate.request.createRequest(params)

    return await axios
      // .get(apiMock.STOCK_MOVE_ARRIVAL_OPERATION)
      .post(`${api.NEXTENGINE_COOPERATE_CONFIG_UPDATE}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
